import React, { Component } from 'react';
import chunk from 'lodash/chunk';
import PropTypes from 'prop-types';
import DrawingCard from '../DrawingCard';
import './Carousel.css';

const CHUNK_SIZE = 3;
const MAX_PAGES = 20;

class DrawingCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: props.index
    };
  }

  incActiveIndex(val) {
    const drawingsChunk = this.getItems();
    let newIndex = this.state.index + val;
    newIndex = newIndex % drawingsChunk.length;
    newIndex = newIndex < 0 ? 0 : newIndex;
    this.props.onSelect && this.props.onSelect(newIndex);
    this.setState({
      index: newIndex
    });
  }

  getItems() {
    return this.props.items
      ? chunk(this.props.items, CHUNK_SIZE).slice(0, MAX_PAGES)
      : [];
  }

  render() {
    const drawings = this.props.items;
    return (
      this.props.items.length > 0 && (
        <div className="drawings-list-content">
          <div className="drawings-page">
            {drawings.map(drawing => (
              <DrawingCard
                drawing={drawing}
                key={'DRWNG' + drawing.id}
                onAction={this.props.onAction}
                showDrumState={false}
                showName={true}
              />
            ))}
          </div>
          {/* <Ticker className="thin" /> */}
        </div>
      )
    );
  }
}

DrawingCarousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onAction: PropTypes.func,
  onSelect: PropTypes.func,
  index: PropTypes.number
};

export default DrawingCarousel;
